import React from 'react';

import FormControlLabel from "../mui/FormControlLabel";
import AutoComplete from "../mui/AutoComplete";
import FormControl from "../mui/FormControl";
import Typography from "../mui/Typography";
import Checkbox from "../mui/Checkbox";
import styled from "@emotion/styled";
import Stack from "../mui/Stack";
import Box from "../mui/Box";


interface RatioButton { label: string; value: string;}
interface Options { label: string; id:number;}
interface Data { name: string; label: string; options: Options[] | string[]};
interface Filter { label: string; id: number | string} 

interface Props {  
  data: Data[]
  ratioBtn: RatioButton[];
  filter: Filter | string | any;
  handleFilterFormChange: (field: string, value: any) => void;
  isDisableMedalsField: boolean;
}

const FilterForm: React.FC<Props> = ({
  data,
  ratioBtn,
  filter,
  handleFilterFormChange,
  isDisableMedalsField,
}) => {

  return (
    <Stack>
      <Stack>
        <Typography>Region</Typography>
        <StyledCheckboxGroup>
          {ratioBtn.map((btn) => (
            <FormControlLabel
              key={btn.value}
              control={
                <Checkbox
                  // {...register("filter.region")}
                  checked={filter.region === btn.value || false}
                  onChange={() => handleFilterFormChange("region", btn.value)}
                  sx={{
                    "&.Mui-checked": {
                      color: "#FFCA09",
                    },
                    marginRight: "-7px",
                  }}
                />
              }
              label={btn.label}
              value={btn.value}
            />
          ))}
        </StyledCheckboxGroup>
      </Stack>


      {data?.map(({ name, label, options }) => (

        <Stack key={name}>
          <Stack style={{marginBottom:"10px"}}>
            <StyledLabel>{label}</StyledLabel>
            <FormControl fullWidth>
              <AutoComplete
                id={`${name}-select`}
                value={label == "Medals" && !isDisableMedalsField ? null : filter[name] || []}
                options={label == "Medals" && !isDisableMedalsField ? [] : options}
                onChange={(newValue: any) => handleFilterFormChange(`${name}`, newValue)}
                placeholder={label == "Medals" && !isDisableMedalsField ? "Disabled" : `Select ${label}`}
                sx={{ backgroundColor: "#fff" }}
                disabled= {label == "Medals" && !isDisableMedalsField}
              />
            </FormControl>
          </Stack>
        </Stack>
      ))}
    </Stack>
  );
};

const StyledLabel = styled(Box)(({ theme }) => ({
  fontSize: "14px !important",
  marginBottom: "3px !important",
  fontWeight: "500 !important",
  color: "#191919 !important",
}));

const StyledCheckboxGroup = styled(Stack)({
  flexDirection: "row",
  marginRight: "8px",
});


export default FilterForm;
